<template>
  <v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="primary--text pb-2">Chat Settings</h2>
        <p>The Chat Settings page allows users to customize their chat experience to suit their preferences. Here, users
          can adjust various settings such as language, chat theme, and text size. They can enable or disable features
          like message notifications, typing indicators, and chat history saving. Users also have the option to set
          conversation privacy controls, filter out specific content, and manage blocked or muted contacts. The page is
          designed to provide a seamless and personalized chat experience, ensuring that users can interact in a way
          that feels comfortable and tailored to their needs..</p>
      </v-flex>
      <v-flex xs12 sm12
        :class="{ 'pr-0 pb-4 mt-3': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp }">
        <v-switch
          v-model="chatMemoryEnabled"
          label="Chat Memory"
          color="primary"
        />
      </v-flex>
      <v-flex xs12 sm12
        :class="{ 'pr-0 pb-4 mt-3': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp }">
        <v-textarea v-model="chatBriefing" label="Chat Briefing" box
          @keyup="$emit('update-account-data', { key: 'changedChatBriefing', value: chatBriefing })"></v-textarea>
      </v-flex>
      <v-flex xs12 sm12
        :class="{ 'pr-0 pb-4 mt-3': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp }">
        <v-textarea v-model="chatReportsText" label="Chat Reports (JSON)" box
          placeholder='{"report_key": {"tool_name": "...", "tool_parameters": {...}, "return_tool_results_directly": true, "display": {...}}}'
          @keyup="onChatReportsInput"></v-textarea>
        <p class="caption grey--text">Keys are report keys; values are the full response template (tool_name, tool_parameters, return_tool_results_directly, display).</p>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>

export default {
  name: "account-details",
  props: ["account"],
  data() {
    return {
      chatBriefing: "",
      chatMemoryEnabled: false,
      chatReportsText: ""
    }
  },
  watch: {
    account: {
      handler(newAccount) {
        if (newAccount) {
          this.chatBriefing = newAccount.chatBriefing
          this.chatMemoryEnabled = !!newAccount.chatMemoryEnabled
          const cr = newAccount.chatReports
          this.chatReportsText = (cr != null && typeof cr === "object") ? JSON.stringify(cr, null, 2) : (typeof cr === "string" ? cr : "{}")
        }
      },
      immediate: true
    },
    chatMemoryEnabled(newVal) {
      if (this.account && !!this.account.chatMemoryEnabled !== newVal) {
        this.$emit("update-account-data", {
          key: "changedChatMemoryEnabled",
          value: newVal
        })
      }
    }
  },
  methods: {
    onChatReportsInput() {
      let value = {}
      try {
        value = this.chatReportsText.trim() ? JSON.parse(this.chatReportsText) : {}
      } catch (e) {
        return
      }
      this.$emit("update-account-data", { key: "changedChatReports", value })
    }
  }
}
</script>

<style lang="scss" scoped>
textarea {
  width: 100%;
  height: 40vh;
}
</style>